let toTimeText = (timeStamp, simple) => {
	var dateTime = new Date(timeStamp)
	var currentTime = Date.parse(new Date()); //当前时间
	var timeDiff = currentTime - dateTime; //与当前时间误差
	var timeText = '';

	if (timeDiff <= 60000) { //一分钟内
		timeText = '刚刚';
	} else if (timeDiff > 60000 && timeDiff < 3600000) {
		//1小时内
		timeText = Math.floor(timeDiff / 60000) + '分钟前';
	} else if (dateTime.toDateString() === new Date().toDateString()) {
		// 今天
		timeText = formatDateTime(dateTime).substr(11, 5); // HH:mm
	} else if (isYestday(dateTime)) {
		// 昨天
		timeText = '昨天 ' + formatDateTime(dateTime).substr(11, 5); // 昨天 HH:mm
	} else if (isThisWeek(dateTime)) {
		// 本周但不是今天
		timeText = getWeekDayName(dateTime); // 只显示周几
	} else if (isYear(dateTime)) {
		// 今年但不是本周
		timeText = formatDateTime(dateTime).substr(5, 5); // 只显示MM/dd
	} else {
		// 不属于今年
		timeText = formatDateTime(dateTime); // yyyy/MM/dd HH:mm:ss
		if (simple) {
			timeText = timeText.substr(2, 8);
		}
	}
	return timeText;
}

let isYestday = (date) => {
	var yesterday = new Date(new Date() - 1000 * 60 * 60 * 24);
	return yesterday.getYear() === date.getYear() &&
		yesterday.getMonth() === date.getMonth() &&
		yesterday.getDate() === date.getDate();
}

let isYear = (date) => {
	return date.getYear() === new Date().getYear();
}

let formatDateTime = (date) => {
	if (date === '' || !date) {
		return ''
	}
	var dateObject = new Date(date)
	var y = dateObject.getFullYear()
	var m = dateObject.getMonth() + 1
	m = m < 10 ? ('0' + m) : m
	var d = dateObject.getDate()
	d = d < 10 ? ('0' + d) : d
	var h = dateObject.getHours()
	h = h < 10 ? ('0' + h) : h
	var minute = dateObject.getMinutes()
	minute = minute < 10 ? ('0' + minute) : minute
	var second = dateObject.getSeconds()
	second = second < 10 ? ('0' + second) : second
	return y + '/' + m + '/' + d + ' ' + h + ':' + minute + ':' + second
}

let getWeekDayName = (date) => {
	const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
	return weekDays[date.getDay()];
}

let isThisWeek = (date) => {
	const now = new Date();
	const nowDay = now.getDay() === 0 ? 7 : now.getDay(); // treat Sunday as 7
	const monday = new Date(now);
	monday.setDate(now.getDate() - nowDay + 1);
	monday.setHours(0,0,0,0);
	const sunday = new Date(monday);
	sunday.setDate(monday.getDate() + 6);
	sunday.setHours(23,59,59,999);
	return date >= monday && date <= sunday;
}


export {
	toTimeText,
	isYestday,
	isYear,
	formatDateTime,
	getWeekDayName,
	isThisWeek
}